import isEmpty from 'lodash/fp/isEmpty';
import { DEFAULT_ROUTE } from '../../common/constants';
import type { RootDispatch, RootState } from '../../configuration/setup/store';
import { updateDraftExistsFlag, updatePage } from '../../store/app/appSlice';
import { selectCurrentTour, selectItineraries, selectSelectedItinerary } from '../../store/tour/tourSelectors';
import { updateTourId, updateTourItineraryId } from '../../store/tour/tourSlice';
import { prefillTourSettings, reapplyVehicleProfileTourFields } from './prefillTourSettings';

const selectSeededItineraryId = (state: RootState): string | undefined => {
    const itineraries = selectItineraries(state);
    const selectedItinerary = selectSelectedItinerary(state);
    return itineraries?.[selectedItinerary ?? 0]?.itineraryId;
};

export const editTour = (dispatch: RootDispatch, getState: () => RootState): void => {
    const state = getState();
    const currentTour = selectCurrentTour(state);
    const itineraries = selectItineraries(state);

    if (!currentTour?.tourId || isEmpty(itineraries)) {
        return;
    }

    dispatch(prefillTourSettings);
    dispatch(updateTourId(currentTour.tourId));
    dispatch(updateTourItineraryId(selectSeededItineraryId(state)));
    dispatch(updateDraftExistsFlag(false));
    dispatch(updatePage(DEFAULT_ROUTE));

    // Fire-and-forget — editTour itself stays synchronous (Requirement 5.2)
    void reapplyVehicleProfileTourFields(dispatch, getState, currentTour);
};
